// extracted by mini-css-extract-plugin
export default {"inputBox":"Textarea_inputBox__5CyL8","inputText":"Textarea_inputText__g6o2n","inputlabel":"Textarea_inputlabel__vsll6","error":"Textarea_error__N3aaF"};